import Input from '../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../Core/Fields/Floating/SelectSearch';
import GetIcon from '../../../utils/Icon';
import VersionHistory from '../../../utils/VersionHistory';
import { useState } from 'react';

const Tab1 = ({ WOI,WOBOM,qty, podate, ponumber,activityboll }) => {
  const [showActivity, setShowActivity] = useState(true);

  return (
    <div className="row sidebarbox m-0 d-flex flex-column" style={{ padding: "8px", borderRadius: "5px",height: '72vh', overflowY: 'scroll',flexWrap:'nowrap'}}>
     
     <div className="col-12">
      <div className="row">
      <div className="col-md-6 mt-1 mb-2" >
        <Input id="orderNo" label="No." readOnly value={ponumber} style={{ height: '30px' }} />
      </div>
      <div className="col-md-6 mt-1">
        <Input id="orderdatepo" type="date" style={{ height: '30px' }} label="Date" readOnly value={podate.podate} onChange={(e) => podate.setpodate(e.target.value)} />
      </div>
      </div>
     </div>
      
      <div className="col-12 mb-2">
        <Input id="orderNo" label="Item To Manufacture" readOnly value={WOI.selectWOItem} style={{ height: '30px' }} />
      </div>
      <div className="col-12 mb-2">
        <Input id="bomno" label="BOM No." readOnly value={WOBOM.selectWOBOM} style={{ height: '30px' }} />

      </div>
   
      <div className="col-12 ">
        <Input id="orderdatepo" type="number" style={{ height: '30px',border:qty.Error ? "1px solid red" : '' }} readOnly label="Qty To Manufacture" value={qty.QtyToManufacture} onChange={(e) => qty.setQtyToManufacture(e.target.value)} />
        
      </div>

      <div >

        <div className="col-12">
          <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
            <p className="firstcolor m-0">
              Activity
            </p>
            <GetIcon
              iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
              size={22}
            />
          </div>

          {showActivity && (
            <VersionHistory doctype="Work Order" docname={ponumber} activityboll={activityboll} />

          )}
        </div>


      </div>
    


    </div>
  )
}

export default Tab1